import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { on } from '@ember/modifier';
import BsCollapse from 'ember-bootstrap/components/bs-collapse';
import CollapseToggle from 'cpc-license-manager/components/collapse-toggle';
class OptionsCallout extends Component {
    @tracked
    collapsedProp;
    get collapsed() {
        if (isEmpty(this.collapsedProp)) {
            return this.args.collapsed;
        }
        return this.collapsedProp;
    }
    set collapsed(value) {
        this.collapsedProp = value;
    }
    get showCheckAll() {
        return !isEmpty(this.args.checkAll);
    }
    get allChecked() {
        return this.args.options?.every((el)=>el.enabled);
    }
    @action
    checkAll(e) {
        const { name, checked } = e.currentTarget;
        this.args.checkAll?.(name, checked);
    }
    @action
    change(e) {
        const { name, checked } = e.currentTarget;
        this.args.optionChanged?.(name, checked);
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <div class="callout {{@calloutClass}}">
      <div class="d-flex align-items-center">
        {{#if this.showCheckAll}}
          <input
            type="checkbox"
            name={{@optionsGroup}}
            checked={{this.allChecked}}
            {{on 'click' this.checkAll}}
            class="me-2"
          />
        {{/if}}
        <div class="h4 mb-0 me-auto">
          {{@title}}
        </div>
        <CollapseToggle @model={{this}} @collapsed={{this.collapsed}} @property="collapsed" />
      </div>
      <div class="row">
        <div class="col">
          <BsCollapse @collapsed={{this.collapsed}}>
            <hr />
            <div class="n-column-items">
              {{#each @options as |option|}}
                <div class="n-column-item">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        name={{option.key}}
                        checked={{option.enabled}}
                        {{on 'click' this.change}}
                        class="form-check-input"
                      />
                      {{option.label}}
                    </label>
                  </div>
                </div>
              {{/each}}
            </div>
          </BsCollapse>
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default OptionsCallout;
